import { render, staticRenderFns } from "./select_items.vue?vue&type=template&id=4d1c0668&scoped=true&"
import script from "./select_items.vue?vue&type=script&lang=js&"
export * from "./select_items.vue?vue&type=script&lang=js&"
import style0 from "./select_items.vue?vue&type=style&index=0&id=4d1c0668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c0668",
  null
  
)

export default component.exports